/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.admpb = require('./entrytype_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.EntryTypeServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.EntryTypeServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ListEntryTypeRequest,
 *   !proto.admpb.ListEntryTypeResponse>}
 */
const methodDescriptor_EntryTypeService_ListEntryType = new grpc.web.MethodDescriptor(
  '/admpb.EntryTypeService/ListEntryType',
  grpc.web.MethodType.UNARY,
  proto.admpb.ListEntryTypeRequest,
  proto.admpb.ListEntryTypeResponse,
  /**
   * @param {!proto.admpb.ListEntryTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListEntryTypeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.ListEntryTypeRequest,
 *   !proto.admpb.ListEntryTypeResponse>}
 */
const methodInfo_EntryTypeService_ListEntryType = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ListEntryTypeResponse,
  /**
   * @param {!proto.admpb.ListEntryTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListEntryTypeResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ListEntryTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ListEntryTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ListEntryTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.EntryTypeServiceClient.prototype.listEntryType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.EntryTypeService/ListEntryType',
      request,
      metadata || {},
      methodDescriptor_EntryTypeService_ListEntryType,
      callback);
};


/**
 * @param {!proto.admpb.ListEntryTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ListEntryTypeResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.EntryTypeServicePromiseClient.prototype.listEntryType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.EntryTypeService/ListEntryType',
      request,
      metadata || {},
      methodDescriptor_EntryTypeService_ListEntryType);
};


module.exports = proto.admpb;

